import {
  CurrencyTextSymbolTypes,
  TypesCurrencyTextSymbol,
} from 'shared/constants'

export const getCurrencyTextSymbol = (type?: CurrencyTextSymbolTypes) => {
  return TypesCurrencyTextSymbol[type || TypesCurrencyTextSymbol.KGS.key]?.name
}
